import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { TmpSellerOrderLineContainerModel } from '../../../../../models';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel, Pagination, PagingResponseModel } from '../shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TmpSellerOrderLineService extends BaseApiTemplateService<TmpSellerOrderLineContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + '/mkp/tmp-seller-order-line';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + '/mkp/tmp-seller-order-line';
    this.httpClient = http;
  }

  getByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<TmpSellerOrderLineContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/backoffice-ep/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<TmpSellerOrderLineContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  getByGenericDocLine(
    genericDocLineGuid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(
      this.apiUrl + '/seller-allocation-queue-processing-list/backoffice-ep' + '/' + genericDocLineGuid,
      this.getHttpHeader(visa)
    );
  }

  postByCustomPath(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<TmpSellerOrderLineContainerModel>> {

    let customPath;

    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customPath = this.apiUrl + '/tmp-seller-order-line-create/backoffice-ep'
    }
    return this.httpClient.post<ApiResponseModel<TmpSellerOrderLineContainerModel>>(
      customPath,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}